import { Box, Container, Heading, Text, VStack, AspectRatio, Link } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

const sessionData = [
  {
    id: 1,
    title: 'Introducción a la IA en Educación',
    description: 'Fundamentos de la Inteligencia Artificial y su impacto en la educación moderna. Conceptos fundamentales',
    youtubeUrl: 'https://www.youtube.com/embed/nRvZgQo-DQc',
    formUrl: 'https://forms.gle/FTARMiwe1vSUdQzZ6',
    materials: [
      {
        category: 'Recursos Fundamentales',
        items: [
          { title: 'Glosario de conceptos IA básicos', url: 'https://castrobarros.edu.ar/ia/Glosario_IA_Educacion.pdf' },
          { title: 'OpenAI', url: 'https://openai.com/es-ES/' },
          { title: 'ChatGPT', url: 'https://openai.com/es-ES/chatgpt/overview/' },
          { title: 'Embedding Projetor', url: 'https://projector.tensorflow.org/' },
          { title: 'Data Center XAI', url: 'https://x.com/elonmusk/status/1827981493924155796?s=46&t=gB3Dov3D_V7U-scv3DF43w' },
          { title: 'Monitoreo de Data Center OpenAI', url: 'https://status.openai.com/' }
        ]
      },
      {
        category: 'Herramientas Técnicas',
        items: [
          { title: 'Embedding Projetor', url: 'https://projector.tensorflow.org/' },
          { title: 'Data Center XAI', url: 'https://x.com/elonmusk/status/1827981493924155796?s=46&t=gB3Dov3D_V7U-scv3DF43w' },
          { title: 'Monitoreo de Data Center OpenAI', url: 'https://status.openai.com/' }
        ]
      },
      {
        category: 'Material Complementario',
        items: [
          { title: 'IA en el 2027', url: 'https://ai-2027.com/' },
          { title: 'Película: "Código Enigma" o "The Imitation Game" en Inglés', url: 'https://letterboxd.com/film/the-imitation-game/' }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Herramientas de IA para Educadores',
    description: 'Exploración de herramientas prácticas de IA para mejorar la experiencia educativa.',
    youtubeUrl: 'https://youtube.com/embed/SIRpxvph8Go',
    formUrl: 'https://forms.gle/NzMkgk4ss1FhL2sUA',
    materials: [
      {
        category: 'Asistentes de IA',
        items: [
          { title: 'ChatGPT', url: 'https://chatgpt.com' },
          { title: 'Gemini', url: 'https://gemini.google.com/app?hl=es' },
          { title: 'Grok', url: 'https://grok.com/' }
        ]
      },
      {
        category: 'Herramientas de Investigación',
        items: [
          { title: 'Consensus', url: 'https://consensus.app/?home=true' },
          { title: 'OpenEvidence', url: 'https://www.openevidence.com/' },
          { title: 'Elicit', url: 'https://elicit.com/welcome' }
        ]
      },
      {
        category: 'Material Complementario',
        items: [
          { title: 'Película recomendada: HER', url: 'https://letterboxd.com/film/her/' }
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Diseño de Experiencias Educativas con IA',
    description: 'Estrategias para integrar la IA en el diseño de experiencias de aprendizaje.',
    youtubeUrl: 'https://youtube.com/embed/mJ1jdbUCIt0',
    formUrl: 'https://forms.gle/dkgqEEuvXGFUMy9s8',
    materials: [
      {
        category: 'Herramientas de Creación',
        items: [
          { title: 'Notebooklm', url: 'https://notebooklm.google.com/app?hl=es' },
          { title: 'Leonardo: Crear Imágenes', url: 'https://app.leonardo.ai/ ' },
          { title: 'Heygen: Crear Avatar', url: 'https://www.heygen.com/' },
          { title: 'Elevenlabs', url: 'https://elevenlabs.io/' }
        ]
      },
      {
        category: 'Asistentes de IA Avanzados',
        items: [
          { title: 'Claude', url: 'https://claude.ai/' },
          { title: 'Perplexity', url: 'https://perplexity.ai/' },
          { title: 'Q-wen', url: 'https://chat.qwen.ai/' },
          { title: 'DeepSeek', url: 'https://www.deepseek.com/en' },
          { title: 'Huggingface', url: 'https://huggingface.co/spaces' }
        ]
      },
      {
        category: 'Herramientas de Productividad',
        items: [
          { title: 'Formularios de Google: desde cero', url: 'https://youtu.be/2brDq41dMyE' },
          { title: 'Transcribir audios', url: 'https://whisper-web-two.vercel.app/' },
          { title: 'Tactiq: Transcribir reuniones Meet', url: 'https://app.tactiq.io/' },
          { title: 'GPT: Corrector de exámenes', url: 'https://chatgpt.com/g/g-680cffbae5f481918f1f33ce07de05c5-corrector-de-examenes' }
        ]
      },
      {
        category: 'Tutoriales',
        items: [
          { title: 'Notebooklm: configurar salida de audio en español', url: 'https://www.youtube.com/watch?v=5182MQq4ZkU' },
          { title: 'Huggingface: De texto a podcast', url: 'https://huggingface.co/spaces/saq1b/podcastgen' }
        ]
      }
    ]
  },
  {
    id: 4,
    title: 'El Futuro de la Educación con IA',
    description: 'Tendencias futuras y preparación para la evolución de la IA en educación.',
    youtubeUrl: 'https://www.youtube.com/embed/dN6JqDQOGe0',
    formUrl: 'https://forms.gle/F2JXEPCq2pr8U1rSA',
    materials: [
      {
        category: 'Aplicaciones Móviles',
        items: [
          { title: 'ChatGPT para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.openai.chatgpt&hl=es_AR' },
          { title: 'ChatGPT para IPHONE', url: 'https://apps.apple.com/ar/app/chatgpt/id6448311069' },
          { title: 'Gemini para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.google.android.apps.bard&hl=es_AR' },
          { title: 'Gemini para IPHONE', url: 'https://apps.apple.com/es/app/google-gemini/id6477489729' },
          { title: 'Copilot para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.microsoft.copilot&hl=es_AR' },
          { title: 'Copilot para IPHONE', url: 'https://apps.apple.com/es/app/microsoft-copilot/id6472538445' },
          { title: 'Claude para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.anthropic.claude&hl=es_AR' },
          { title: 'Claude para IPHONE', url: 'https://apps.apple.com/hn/app/claude-by-anthropic/id6473753684' },
          { title: 'Perplexity para ANDROID', url: 'https://play.google.com/store/apps/details?id=ai.perplexity.app.android&hl=es_AR' },
          { title: 'Perplexity para IPHONE', url: 'https://apps.apple.com/es/app/perplexity-ask-anything/id1668000334' },
          { title: 'DeepSeek para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.deepseek.chat&hl=es_AR' },
          { title: 'DeepSeek para IPHONE', url: 'https://apps.apple.com/es/app/deepseek-asistente-de-ia/id6737597349' },
          { title: 'NotebookLM para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.google.android.apps.labs.language.tailwind&hl=es_AR' },
          { title: 'NotebookLM para IPHONE', url: 'https://apps.apple.com/us/app/notebooklm/id6737527615' }
        ]
      },
      {
        category: 'Demostraciones Interactivas',
        items: [
          { title: 'Claude: TATETI', url: 'https://claude.ai/public/artifacts/c04153a7-d249-4e3a-b214-8d815fd8485c' },
          { title: 'Claude: CALCULADORA', url: 'https://claude.ai/public/artifacts/e672f7b4-3d8d-4095-9999-a0965abf695f' },
          { title: 'ChatGPT: TATETI', url: 'https://chatgpt.com/canvas/shared/681acc255b908191b969cb62f4906be5' }
        ]
      },
      {
        category: 'Material Complementario',
        items: [
          { title: 'LA ERA DEL MÁS ALLÁ: Si los humanos y la IA se unieran', url: 'https://www.youtube.com/watch?v=vp7xoPeWzEw' }
        ]
      }
    ]
  },
  {
    id: 6,
    title: 'Clase adicional de apoyo',
    description: 'Sesión de apoyo y refuerzo de los conceptos vistos en el curso',
    youtubeUrl: 'https://www.youtube.com/embed/pMqxm-85Dbc', 
    formUrl: '',
    materials: [
      {
        category: 'Recursos Complementarios',
        items: [
          { title: 'Khan Academy', url: 'https://es.khanacademy.org/' },
          { title: 'Letsview: para mostrar celular en pantalla de PC', url: 'https://letsview.com/es/screen-mirroring' },
          { title: 'Método Fogg: breve explicación clase 3 de este mismo curso en el año 2024', url: 'https://www.youtube.com/live/NPAl9xDo2TI?si=Yu66_-9pX5elZjzg&t=3386' }
        ]
      }
    ]
  },
  {
    id: 5,
    title: 'Evaluación Final',
    description: 'Muchas gracias por participar en esta capacitación',
    youtubeUrl: 'https://www.youtube.com/embed/Ct_iSup4lGw',
    formUrl: 'https://forms.gle/xppQFLS8eCvQETpo6',
    materials: [
      {
        category: 'Demostraciones Interactivas',
        items: [
          { title: 'ChatGPT: Juego de la viborita', url: 'https://chatgpt.com/canvas/shared/681d442d33d88191b809f4c395fdada7' },
          { title: 'Claude: Juego de la viborita', url: 'https://claude.ai/public/artifacts/3a35d32a-27e3-49a7-ac16-0e7bb1a69690' }
        ]
      }
    ]
  },
  {
    id: 7,
    title: 'Tutorial: Animación de Fotos/Retratos',
    description: 'Como animar una imagen tipo avatar. En este caso al Dr. Pedro Ignacio de Castro Barros',
    youtubeUrl: 'https://www.youtube.com/embed/qARLwpWhiKo',
    formUrl: 'https://forms.gle/xppQFLS8eCvQETpo6',
    materials: [
      {
        category: 'Herramientas de Creación',
        items: [
          { title: 'ChatGPT: para crear o transformar la imagen', url: 'https://quizlet.com/' },
          { title: 'ElevenLabs: para crear la voz', url: 'https://elevenlabs.io/' },
          { title: 'Heygen: para animar la imagen con la voz generada', url: 'https://app.heygen.com/' }
        ]
      }
    ]
  },
  {
    id: 8,
    title: 'Recursos y Materiales del Curso',
    description: 'Acceso centralizado a todos los recursos y materiales utilizados durante la capacitación',
    youtubeUrl: '',
    formUrl: '',
    materials: [
      {
        category: 'Recursos Fundamentales',
        items: [
          { title: 'Glosario de conceptos IA básicos', url: 'https://castrobarros.edu.ar/ia/Glosario_IA_Educacion.pdf' },
          { title: 'OpenAI', url: 'https://openai.com/es-ES/' },
          { title: 'ChatGPT', url: 'https://openai.com/es-ES/chatgpt/overview/' },
          { title: 'Embedding Projetor', url: 'https://projector.tensorflow.org/' },
          { title: 'Data Center XAI', url: 'https://x.com/elonmusk/status/1827981493924155796?s=46&t=gB3Dov3D_V7U-scv3DF43w' },
          { title: 'Monitoreo de Data Center OpenAI', url: 'https://status.openai.com/' }
        ]
      },
      {
        category: 'Asistentes de IA',
        items: [
          { title: 'ChatGPT', url: 'https://chatgpt.com' },
          { title: 'Gemini', url: 'https://gemini.google.com/app?hl=es' },
          { title: 'Claude', url: 'https://claude.ai/' },
          { title: 'Perplexity', url: 'https://perplexity.ai/' },
          { title: 'Grok', url: 'https://grok.com/' },
          { title: 'Q-wen', url: 'https://chat.qwen.ai/' },
          { title: 'DeepSeek', url: 'https://www.deepseek.com/en' },
          { title: 'Huggingface', url: 'https://huggingface.co/spaces' }
        ]
      },
      {
        category: 'Herramientas de Investigación',
        items: [
          { title: 'Consensus', url: 'https://consensus.app/?home=true' },
          { title: 'OpenEvidence', url: 'https://www.openevidence.com/' },
          { title: 'Elicit', url: 'https://elicit.com/welcome' }
        ]
      },
      {
        category: 'Herramientas de Creación',
        items: [
          { title: 'Notebooklm', url: 'https://notebooklm.google.com/app?hl=es' },
          { title: 'Leonardo: Crear Imágenes', url: 'https://app.leonardo.ai/' },
          { title: 'Heygen: Crear Avatar', url: 'https://www.heygen.com/' },
          { title: 'Elevenlabs', url: 'https://elevenlabs.io/' }
        ]
      },
      {
        category: 'Herramientas de Productividad',
        items: [
          { title: 'Formularios de Google: desde cero', url: 'https://youtu.be/2brDq41dMyE' },
          { title: 'Transcribir audios', url: 'https://whisper-web-two.vercel.app/' },
          { title: 'Tactiq: Transcribir reuniones Meet', url: 'https://app.tactiq.io/' },
          { title: 'GPT: Corrector de exámenes', url: 'https://chatgpt.com/g/g-680cffbae5f481918f1f33ce07de05c5-corrector-de-examenes' }
        ]
      },
      {
        category: 'Aplicaciones Móviles',
        items: [
          { title: 'ChatGPT para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.openai.chatgpt&hl=es_AR' },
          { title: 'ChatGPT para IPHONE', url: 'https://apps.apple.com/ar/app/chatgpt/id6448311069' },
          { title: 'Gemini para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.google.android.apps.bard&hl=es_AR' },
          { title: 'Gemini para IPHONE', url: 'https://apps.apple.com/es/app/google-gemini/id6477489729' },
          { title: 'Claude para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.anthropic.claude&hl=es_AR' },
          { title: 'Claude para IPHONE', url: 'https://apps.apple.com/hn/app/claude-by-anthropic/id6473753684' },
          { title: 'Perplexity para ANDROID', url: 'https://play.google.com/store/apps/details?id=ai.perplexity.app.android&hl=es_AR' },
          { title: 'Perplexity para IPHONE', url: 'https://apps.apple.com/es/app/perplexity-ask-anything/id1668000334' },
          { title: 'DeepSeek para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.deepseek.chat&hl=es_AR' },
          { title: 'DeepSeek para IPHONE', url: 'https://apps.apple.com/es/app/deepseek-asistente-de-ia/id6737597349' },
          { title: 'NotebookLM para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.google.android.apps.labs.language.tailwind&hl=es_AR' },
          { title: 'NotebookLM para IPHONE', url: 'https://apps.apple.com/us/app/notebooklm/id6737527615' }
        ]
      },
      {
        category: 'Demostraciones Interactivas',
        items: [
          { title: 'Claude: TATETI', url: 'https://claude.ai/public/artifacts/c04153a7-d249-4e3a-b214-8d815fd8485c' },
          { title: 'Claude: CALCULADORA', url: 'https://claude.ai/public/artifacts/e672f7b4-3d8d-4095-9999-a0965abf695f' },
          { title: 'ChatGPT: TATETI', url: 'https://chatgpt.com/canvas/shared/681acc255b908191b969cb62f4906be5' },
          { title: 'ChatGPT: Juego de la viborita', url: 'https://chatgpt.com/canvas/shared/681d442d33d88191b809f4c395fdada7' },
          { title: 'Claude: Juego de la viborita', url: 'https://claude.ai/public/artifacts/3a35d32a-27e3-49a7-ac16-0e7bb1a69690' }
        ]
      },
      {
        category: 'Material Complementario',
        items: [
          { title: 'IA en el 2027', url: 'https://ai-2027.com/' },
          { title: 'Película: "Código Enigma" o "The Imitation Game" en Inglés', url: 'https://letterboxd.com/film/the-imitation-game/' },
          { title: 'Película recomendada: HER', url: 'https://letterboxd.com/film/her/' },
          { title: 'LA ERA DEL MÁS ALLÁ: Si los humanos y la IA se unieran', url: 'https://www.youtube.com/watch?v=vp7xoPeWzEw' }
        ]
      },
      {
        category: 'Tutoriales',
        items: [
          { title: 'Notebooklm: configurar salida de audio en español', url: 'https://www.youtube.com/watch?v=5182MQq4ZkU' },
          { title: 'Huggingface: De texto a podcast', url: 'https://huggingface.co/spaces/saq1b/podcastgen' }
        ]
      },
      {
        category: 'Asistentes de IA Avanzados',
        items: [
          { title: 'DeepSeek', url: 'https://www.deepseek.com/en' },
          { title: 'Huggingface', url: 'https://huggingface.co/spaces' }
        ]
      },
      {
        category: 'Herramientas de Investigación',
        items: [
          { title: 'Consensus', url: 'https://consensus.app/?home=true' },
          { title: 'OpenEvidence', url: 'https://www.openevidence.com/' },
          { title: 'Elicit', url: 'https://elicit.com/welcome' }
        ]
      },
      {
        category: 'Herramientas de Creación',
        items: [
          { title: 'Notebooklm', url: 'https://notebooklm.google.com/app?hl=es' },
          { title: 'Leonardo: Crear Imágenes', url: 'https://app.leonardo.ai/' },
          { title: 'Heygen: Crear Avatar', url: 'https://www.heygen.com/' },
          { title: 'Elevenlabs', url: 'https://elevenlabs.io/' }
        ]
      },
      {
        category: 'Aplicaciones Móviles',
        items: [
          { title: 'ChatGPT para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.openai.chatgpt&hl=es_AR' },
          { title: 'ChatGPT para IPHONE', url: 'https://apps.apple.com/ar/app/chatgpt/id6448311069' },
          { title: 'Gemini para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.google.android.apps.bard&hl=es_AR' },
          { title: 'Gemini para IPHONE', url: 'https://apps.apple.com/es/app/google-gemini/id6477489729' },
          { title: 'Claude para ANDROID', url: 'https://play.google.com/store/apps/details?id=com.anthropic.claude&hl=es_AR' },
          { title: 'Claude para IPHONE', url: 'https://apps.apple.com/hn/app/claude-by-anthropic/id6473753684' }
        ]
      }
    ]
  }
];



const Session = () => {
  const { id } = useParams();
  const session = sessionData[parseInt(id) - 1];

  if (!session) {
    return (
      <Container maxW="container.xl" py={20}>
        <Text>Sesión no encontrada</Text>
      </Container>
    );
  }

  return (
    <Box bg="gray.50" minH="calc(100vh - 64px)" pt={8}>
      <Container maxW="container.xl" py={12}>
        <VStack spacing={8} align="stretch">
          <Box>
            <Heading
              size="xl"
              bgGradient="linear(to-r, blue.400, blue.600)"
              bgClip="text"
              mb={4}
            >
              {session.title}
            </Heading>
            <Text fontSize="lg" color="gray.600" mb={8}>
              {session.description}
            </Text>
          </Box>

          {session.youtubeUrl && (
            <Box bg="white" p={6} rounded="xl" shadow="md">
              <Heading size="md" mb={4}>Transmisión en Vivo</Heading>
              <AspectRatio ratio={16 / 9} mb={4}>
                <iframe
                  src={session.youtubeUrl}
                  title={`Sesión ${session.id}`}
                  allowFullScreen
                  frameBorder="0"
                />
              </AspectRatio>
            </Box>
          )}

          {session.id !== 6 && session.id !== 7 && (
            <Box bg="white" p={6} rounded="xl" shadow="md">
              <Heading size="md" mb={4}>{session.id === 5 ? 'Evaluación Final' : 'Registro de Asistencia'}</Heading>
              <Text mb={4}>
                {session.id === 5 
                  ? 'No se apresure. Tiene una semana para completar este examen. Recuerde que una vez completado, no podrá editar las respuestas.' 
                  : 'Por favor, complete el formulario para registrar su asistencia al encuentro.'}
              </Text>
              <Link
                href={session.formUrl}
                isExternal
                color="blue.500"
                fontWeight="bold"
                _hover={{ textDecoration: 'none', color: 'blue.600' }}
              >
                {session.id === 5 ? 'COMPLETAR EVALUACIÓN' : 'REGISTRAR ASISTENCIA'}
              </Link>
            </Box>
          )}
          <Box bg="white" p={6} rounded="xl" shadow="md">
            <Heading size="md" mb={4}>{session.id === 7 ? 'Recursos usados en esta capacitación' : 'Materiales del Encuentro'}</Heading>
            <VStack align="stretch" spacing={6}>
              {session.materials.map((category, index) => (
                <Box key={index}>
                  <Heading size="sm" mb={3} color="gray.700">
                    {category.category}
                  </Heading>
                  <VStack align="stretch" spacing={2}>
                    {category.items.map((item, itemIndex) => (
                      <Link
                        key={itemIndex}
                        href={item.url}
                        isExternal
                        color="blue.500"
                        fontWeight="medium"
                        _hover={{ textDecoration: 'none', color: 'blue.600' }}
                        display="flex"
                        alignItems="center"
                      >
                        {item.title}
                      </Link>
                    ))}
                  </VStack>
                </Box>
              ))}
            </VStack>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default Session;